export default __webpack_public_path__ + "static/media/handtoCell.c3fc090b.png";